<template>
  <div id="app">
    <!-- <router-view/> -->

    <!-- @showGuidAg="showGuidAg"  该方法为首页专用 -->
    <keep-alive>
      <router-view @showGuidAg="showGuidAg" ref="routerView" v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view @showGuidAg="showGuidAg" ref="routerView" v-if="!$route.meta.keepAlive"></router-view>

    <!-- 底部tab -->
    <!-- <div :class="[{'navbarx':isphone},'navbar']" v-if="flag">
      <div :class="[{'navbar__fixedx':isphone},'navbar__fixed']">
        <ul class="navbar__box">
          <li :class="index==1 ? 'active' : ''" @click="tab('/')">
            <div class="icon icon__home"></div>
            <p class="flbottom">首页</p>
          </li>
          <li :class="index==3 ? 'active' : ''" @click="tab('/vip')">
            <div class="icon icon__vip"></div>
            <p class="flbottom">斐燃会员</p>
          </li>
          <li :class="index==2 ? 'active' : ''" @click="tab('/orderlist')">
            <div class="icon icon__order"></div>
            <p class="flbottom">订单</p>
          </li>
          <li :class="index==4 ? 'active' : ''" @click="tab('/my')">
            <div class="icon icon__my"></div>
            <p class="flbottom">我的</p>
          </li>
        </ul>
      </div>
    </div> -->

    <!-- 引导模块 -->
    <div v-if="false">
      <van-popup v-model="fl_pilotRecomPopupShow" :close-on-click-overlay="false" position="left" :overlay="true">
        <div class="fl_pilotRecom">
          <label @click="closePilotRecommend()" class="fl_pilotRecom_close">跳过</label>
          <van-swipe class="fl_pilotRecom_item" @change="flPilotReOutChange" ref="fl_pilotRecom_item" :show-indicators="false" :vertical="true" :loop="false" style="height: 100vh;width: 100%;">
            <van-swipe-item class="fl_pilotRecom_swipeitem">
              <div :class="[{'fl_psi1H':isHeightPhone==true},'fl_psi1']">
                <img class="fl_psi1_logo" src="./assets/images/guid/logo_home.png" />
                <div class="fl_psi1_title">斐燃会员</div>
                <div :class="[{'fl_psi1_stitleH':isHeightPhone==true},'fl_psi1_stitle']">畅享五星级奢华酒店游泳/健身/瑜伽</div>
              </div>
              <img class="fl_psi1_img" src="./assets/images/guid/title_principleflatten.png" />
            </van-swipe-item>
            <van-swipe-item class="fl_pilotRecom_swipeitem">
              <div :class="[{'fl_psi2_titleH':isHeightPhone==true},'fl_psi2_title']">
                <div class="fl_psi2_title1">国际顶级酒店品牌</div>
                <div :class="[{'fl_psi2_title2H':isHeightPhone==true},'fl_psi2_title2']">International top hotel brand </div>
              </div>
              <div class="fl_psi2_cont">
                <div :class="[{'fl_psi2_cont_bgH':isHeightPhone==true},'fl_psi2_cont_bg']">
                  <div class="fl_psi2_cont_bg_line">
                    <div class="fl_psi2_cont_bg_txt">
                      <div class="fl_psi2_cont_bg_txt1">顶级酒店+顶级设施</div>
                      <div class="fl_psi2_cont_bg_txt2">斐燃会员手机预约<br />以上酒店品牌游泳、健身、瑜伽</div>
                    </div>
                  </div>

                </div>
                <div class="fl_psi2_cont_swiper">
                  <van-swipe @change="flPilotReChange" :autoplay="3000"  :stop-propagation="true" style="width: 100%;" class="fl_psi2_cont_swiper_swipe" indicator-color="white">
                    <van-swipe-item >
                      <img style="width: 100%;" src="./assets/images/guid/pinpai1_principleflatten.png" />
                    </van-swipe-item>
                    <van-swipe-item>
                      <img style="width: 100%;" src="./assets/images/guid/pinpai2_principleflatten.png" />
                    </van-swipe-item>
                    <van-swipe-item >
                      <img style="width: 100%;" src="./assets/images/guid/pinpai3_principleflatten.png" />
                    </van-swipe-item>
                    <template #indicator>
                      <div class="fl_psi2_cont_custom_indicator"><label>{{ fl_psi2_current + 1 }}</label>/3</div>
                    </template>
                  </van-swipe>
                </div>
              </div>
            </van-swipe-item>
            <van-swipe-item class="fl_pilotRecom_swipeitem">
              <div :class="[{'fl_psi3_titleH':isHeightPhone==true},'fl_psi3_title']">
                <div class="fl_psi3_title1">全国50+五星级酒店</div>
                <div class="fl_psi3_title2">50+ five-star hotels nationwide</div>
              </div>
              <div class="fl_psi3_swiper">
                <div class="fl_psi3_swiper_item">
                  <div class="fl_psi3_swiper_item_title">
                    <span @click="flPsi3SwiperTo(0)">
                      上海
                      <img v-show="fl_psi3_current==0" src="./assets/images/guid/popover_border.png" />
                    </span>
                    <span @click="flPsi3SwiperTo(1)">
                      北京
                      <img v-show="fl_psi3_current==1" src="./assets/images/guid/popover_border.png" />
                    </span>
                    <span @click="flPsi3SwiperTo(2)">
                      深圳
                      <img v-show="fl_psi3_current==2" src="./assets/images/guid/popover_border.png" />
                    </span>
                    <span @click="flPsi3SwiperTo(3)">
                      广州
                      <img v-show="fl_psi3_current==3" src="./assets/images/guid/popover_border.png" />
                    </span>
                    <span @click="flPsi3SwiperTo(4)">
                      更多城市
                      <img v-show="fl_psi3_current==4" src="./assets/images/guid/popover_border.png" />
                    </span>
                  </div>
                  <div class="fl_psi3_swiper_item_sw">
                    <van-swipe  ref="flPsi3Swiper" @change="flPilotRe3Change" :autoplay="3000"  :stop-propagation="true" style="width: 100%;" indicator-color="white">
                      <van-swipe-item >
                        <img style="width: 100%;" src="./assets/images/guid/principleshanghai.png" />
                      </van-swipe-item>
                      <van-swipe-item >
                        <img style="width: 100%;" src="./assets/images/guid/principlebeijing.png" />
                      </van-swipe-item>
                      <van-swipe-item >
                        <img style="width: 100%;" src="./assets/images/guid/principleshenzhen.png" />
                      </van-swipe-item>
                      <van-swipe-item >
                        <img style="width: 100%;" src="./assets/images/guid/principleguangzhou.png" />
                      </van-swipe-item>
                      <van-swipe-item >
                        <img style="width: 100%;" src="./assets/images/guid/principlegengduo.png" />
                      </van-swipe-item>
                    </van-swipe>
                  </div>
                  <div class="fl_psi3_swiper_item_tip">&nbsp;&nbsp;&nbsp;&nbsp;酒店名单每月更新&nbsp;&nbsp;&nbsp;&nbsp;手机预约快速下场</div>
                </div>
              </div>
            </van-swipe-item>
            <van-swipe-item class="fl_pilotRecom_swipeitem">
              <div :class="[{'fl_psi4_titleH':isHeightPhone==true},'fl_psi4_title']">
                <div class="fl_psi4_title1">顶级健身器械</div>
                <div class="fl_psi4_title2">Top fitness equipment</div>
              </div>
              <div class="fl_psi4_cont">
                <div :class="[{'fl_psi4_cont_blockH':isHeightPhone==true},'fl_psi4_cont_block']">
                  <div class="fl_psi4_cont_block_item"></div>
                </div>
                <div class="fl_psi4_cont_pos">
                  <img :class="[{'animated bounceInDown':fl_psi0_current==3},'fl_psi4_cont_pos_img1']" src="./assets/images/guid/js_up_img.png" />
                  <img :class="[{'animated rotateInDownRight':fl_psi0_current==3},'fl_psi4_cont_pos_img2']" src="./assets/images/guid/js_up_img2.png"  />
                  <img :class="[{'animated bounceInLeft':fl_psi0_current==3},'fl_psi4_cont_pos_img3']" src="./assets/images/guid/js_left_img3.png" />
                  <img :class="[{'animated bounceInUp':fl_psi0_current==3},'fl_psi4_cont_pos_img4']" src="./assets/images/guid/js_right_img.png" />
                </div>
              </div>
            </van-swipe-item>
            <van-swipe-item class="fl_pilotRecom_swipeitem">
              <div :class="[{'fl_psi4_titleH':isHeightPhone==true},'fl_psi4_title']">
                <div class="fl_psi4_title1">豪华恒温泳池</div>
                <div class="fl_psi4_title2">Luxury heated swimming pool</div>
              </div>
              <div class="fl_psi5_cont">
                <div :class="[{'fl_psi5_cont_blockH':isHeightPhone==true},'fl_psi5_cont_block']">
                  <div class="fl_psi5_cont_block_item"></div>
                </div>
                <div class="fl_psi5_cont_pos">
                  <img :class="[{'animated pulse':fl_psi0_current==4},'fl_psi5_cont_pos_img1']" src="./assets/images/guid/yc_left_img.png" />
                  <img :class="[{'animated pulse':fl_psi0_current==4},'fl_psi5_cont_pos_img2']" src="./assets/images/guid/yc_right_img.png" />
                  <div class="clearboth"></div>
                  <img :class="[{'animated rollIn':fl_psi0_current==4},'fl_psi5_cont_pos_img3']" src="./assets/images/guid/yc_center_img.png" />
                  <img :class="[{'animated slideInUp':fl_psi0_current==4},'fl_psi5_cont_pos_img4']" src="./assets/images/guid/yc_down_img.png" />
                </div>
              </div>
            </van-swipe-item>
            <van-swipe-item class="fl_pilotRecom_swipeitem">
              <div :class="[{'fl_psi4_titleH':isHeightPhone==true},'fl_psi4_title']">
                <div class="fl_psi4_title1">桑拿汗蒸室</div>
                <div class="fl_psi4_title2">Sauna steam room</div>
              </div>
              <div class="fl_psi6_cont">
                <div :class="[{'fl_psi6_cont_blockH':isHeightPhone==true},'fl_psi6_cont_block']">
                  <div class="fl_psi6_cont_block_item"></div>
                </div>
                <div class="fl_psi6_cont_pos">
                  <img :class="[{'animated fadeInLeftBig':fl_psi0_current==5},'fl_psi6_cont_pos_img1']" src="./assets/images/guid/sn_up_img.png">
                  <img :class="[{'animated fadeInUpBig':fl_psi0_current==5},'fl_psi6_cont_pos_img2']" src="./assets/images/guid/sn_down_img.png">
                  <img :class="[{'animated rotateInUpRight':fl_psi0_current==5},'fl_psi6_cont_pos_img3']" src="./assets/images/guid/sn_down_img2.png">
                </div>
              </div>
            </van-swipe-item>
            <van-swipe-item class="fl_pilotRecom_swipeitem">
              <div :class="[{'fl_psi4_titleH':isHeightPhone==true},'fl_psi4_title']">
                <div class="fl_psi4_title1">优雅的低分贝环境</div>
                <div class="fl_psi4_title2">Elegant low-decibel environment</div>
              </div>
              <div class="fl_psi7_cont">
                <div :class="[{'fl_psi7_cont_blockH':isHeightPhone==true},'fl_psi7_cont_block']">
                  <div class="fl_psi7_cont_block_item"></div>
                  <!-- <div  @click="closePilotRecommend()" class="fl_psi7_cont_block_btn">即刻探索</div> -->
                  <img  @click="closePilotRecommend()" class="fl_psi7_cont_block_btn" src="./assets/images/guid/explorer.png" />
                  <v-touch v-on:swipeup="swiperup" >
                    <div class="fl_psi7_cont_block_silder"></div>
                  </v-touch>
                </div>
                <div class="fl_psi7_cont_pos">
                  <img :class="[{'animated rollIn':fl_psi0_current==6}]" src="./assets/images/guid/hj_img.png" />
                  <div>高端人群专享、私密、优雅，<br />舒缓您的心情</div>
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
          <img v-show="fl_psi0_current + 1 < 7" @click="flPilotReOutNext()" :class="[{'fl_pilotRecom_next0':isDownFlatter==0},{'fl_pilotRecom_next1':isDownFlatter==1},{'fl_pilotRecom_next2':isDownFlatter==2},'fl_pilotRecom_next']" src="./assets/images/guid/down_principleflatten.png" />
        </div>
      </van-popup>
    </div>

    <!--  -->
    <!-- <van-popup v-model="flv_activity_first" :close-on-click-overlay='false' :close-on-popstate='true' :style="{ width: '100%',background: 'none' }"  position="center" >
      <div class="flvf_popup">
        <img @click="FLVCloseEnvelopeac()" class="flvf_popup_img1" src="./assets/images/activity/202104/aa5.png" />
        <img @click="FLVCloseEnvelope()" class="flvf_popup_clos" src="./assets/images/activity/202101/close_white.png" />
      </div>
    </van-popup> -->

   <!-- <div class="flvf_popup_minprogress" @touchmove.prevent>
      <div class="flvf_popup_minprogress_img">
        <img class="flvf_popup_minprogress_imgi" src="./assets/images/fc/gh_54de91dcb978_344.jpg" />
      </div>
      <div class="flvf_popup_minprogress_txt">因斐燃生活服务升级，长按识别小程序</div>
    </div> -->


  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        index: 4,
        flag: false,
        isphone:false,//判断是否为iphone
        fl_pilotRecomPopupShow:false,//引导模块
        isHeightPhone:false,//判断是否为长屏机
        fl_psi0_current:0,//引导页最外层独立 swiper 索引
        fl_psi2_current:0,//引导页第二屏独立 swiper 索引
        fl_psi3_current:0,//引导页第三屏独立 swiper 索引
        isDownFlatter:0,//引导页 next icon 状态 1:ios 长屏   2:ios 短屏   0:安卓端

        // 2021活动1
        flv_activity_first:false,
        flv_activity_first_isOpen:0,//0:未开红包 1已开红包
        flv_activity_first_isOpen_over:1,//0:开红包未结束  1:开红包结束
        flv_activity_first_isOpen_btn:0,//与 flv_activity_first_isOpen 同步，比小程序提前执行
        fl_getcouponSuccess:0,
        sbxq:'',//傻逼需求

      }
    },
    created() {
      this.getJsAuth();
      // 判断手机型号
      this.phoneSystem()
    },
    watch: {
      '$route.path': function(newVal, oldVal) {
        let path = this.$route.path;
        if (path == "/") {
          this.index = 1;
          this.flag = true;
        } else if (path == "/orderlist") {
          this.index = 2;
          this.flag = true;
        } else if (path == "/vip") {
          this.index = 3;
          this.flag = true;
        } else if (path == "/my") {
          this.index = 4
          this.flag = true;
        } else {
          this.flag = false;
        }
        if (path == "/activate_single"||path == "/activate_groupe") {
          this.index = -1;
          this.flag = true;
        }
        // // 全局引导模块
        // if(localStorage.getItem('openid')){
        //   if(!localStorage.getItem('fl_pilotRecommend')){
        //     this.isPilotRecom()
        //   }else{
        //     console.log(this.$route)
        //     if(this.$route.name=='index'){
        //       this.FLFirstActivity()
        //     }
        //   }
        // }
      },
    },
    mounted() {
      let path = this.$route.path;
      if (path == "/") {
        this.index = 1;
        this.flag = true;
      } else if (path == "/orderlist") {
        this.index = 2;
        this.flag = true;
      } else if (path == "/vip") {
        this.index = 3;
        this.flag = true;
      } else if (path == "/my") {
        this.index = 4
        this.flag = true;
      } else {
        this.flag = false;
      }
      if (path == "/activate_single"||path == "/activate_groupe") {
        this.index = -1;
        this.flag = true;
      }

    },
    methods: {
      FLVCloseEnvelopeac(){
        var $this=this
        this.flv_activity_first=false
        setTimeout(function(){
          $this.$router.push({
            name:'acfour'
          })
        },300)

      },
      isIphoneX() {
        return /iphone/gi.test(navigator.userAgent) && (screen.height >800 && screen.width == 375)
      },
      phoneSystem(){
        var u = navigator.userAgent;
        var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if(screen.height >800 &&isIOS){
          this.isphone=true
        }else{
          this.isphone=false
        }

        if(screen.height > 800){
          this.isHeightPhone=true
        }else{
          this.isHeightPhone=false
        }

        if(isIOS){
          if(screen.height > 800){
            this.isDownFlatter=1//ios 长屏
          }else{
            this.isDownFlatter=2//ios 短屏
          }
        }else{
          this.isDownFlatter=0//安卓端
        }

      },
      tab(path) {
        if(path=='/orderlist'){
          var $this=this
          sessionStorage.setItem('order_list_status',0)
          setTimeout(function(){
            $this.$router.push({
              name:'orderlist'
            })
          },300)
        }else{
          this.$router.push({
            path: path,
          });
        }

      },
      getJsAuth() {
        let that = this;
        // alert('jWeixin='+JSON.stringify(jWeixin))
        // alert(location.href.split('#')[0])

        // http://test.wxamp.unionfit.cn/Wxsdk/getJsAuth

        var param = {
          url: location.href.split('#')[0]//encodeURIComponent(window.location.href)
        }
        var qs = require('qs');
        let url = this.api.userApi.getykfxqm
        this.axios.post(url, qs.stringify(param), )
        .then((res) => {
           console.log(res)
          wx.config({
            debug: false,
            appId: res.data.appid, // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.noncestr, // 必填，生成签名的随机串
            signature: res.data.signature,
            jsApiList: [
              'updateAppMessageShareData', //自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0） 新接口
              'updateTimelineShareData', //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0） 老接口
              'onMenuShareTimeline', //分享到朋友圈 老接口
              'onMenuShareAppMessage', //分享给盆友 老接口
              'getLocation' //获取定位
              /*
              0: "getLocation"
              1: "onMenuShareTimeline"
              2: "onMenuShareAppMessage"
              3: "onMenuShareQQ"
              4: "onMenuShareWeibo"
              5: "onMenuShareQZone"
              6: "updateAppMessageShareData"
              7: "updateTimelineShareData"
              */
            ]
          });

          wx.checkJsApi({
            jsApiList: [
              'updateAppMessageShareData', //自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0） 新接口
              'updateTimelineShareData', //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0） 老接口
              'onMenuShareTimeline', //分享到朋友圈 老接口
              'onMenuShareAppMessage', //分享给盆友 老接口
              'getLocation' //获取定位
            ], // 需要检测的 JS 接口列表，所有 JS 接口列表见附录2,
            success: function(res) {
              // alert('判断当前客户端版本是否支持指定 JS 接口：'+JSON.stringify(res))
            }
          });


          // var $this = this;
          // alert('拼接路由：'+window.location.protocol+'//'+window.location.host+'/frmonthcard')

          wx.ready(function(){
            // alert('ready')
            var Stitle='斐燃泳健超值月卡￥998限时预售'
            var Sdes='畅享五星级酒店游泳健身'
            var SimgUrl='https://unionfit.oss-cn-shanghai.aliyuncs.com/22/05/monthvip/share.png'



            wx.onMenuShareAppMessage({
              title: Stitle, // 分享标题
              desc: Sdes, //分享描述
              link: window.location.protocol+'//'+window.location.host, // 分享链接
              imgUrl: SimgUrl, // 分享图标
              success() {
                // alert('onMenuShareAppMessage')
              }
            });
            wx.onMenuShareTimeline({
              title:Stitle, // 分享标题
              desc: Sdes, //分享描述
              link: window.location.protocol+'//'+window.location.host, // 分享链接
              imgUrl: SimgUrl, // 分享图标
              success() {
                // alert('onMenuShareTimeline')
              }
            });

            /**
            wx.onMenuShareAppMessage({
              title: Stitle, // 分享标题
              desc: Sdes, //分享描述
              link: window.location.protocol+'//'+window.location.host+'/frmonthcard', // 分享链接
              imgUrl: SimgUrl, // 分享图标
              success() {
                alert('onMenuShareAppMessage')
              }
            });
            wx.onMenuShareTimeline({
              title:Stitle, // 分享标题
              desc: Sdes, //分享描述
              link: window.location.protocol+'//'+window.location.host+'/frmonthcard', // 分享链接
              imgUrl: SimgUrl, // 分享图标
              success() {
                alert('onMenuShareTimeline')
              }
            });

            jWeixin.updateAppMessageShareData({
              title: Stitle, // 分享标题
              desc: Sdes, //分享描述
              link: window.location.protocol+'//'+window.location.host+'', // 分享链接
              imgUrl: SimgUrl, // 分享图标
              success() {
                // alert('updateAppMessageShareData')
              }
            });
            jWeixin.updateTimelineShareData({
              title:Stitle, // 分享标题
              desc: Sdes, //分享描述
              link: window.location.protocol+'//'+window.location.host+'', // 分享链接
              imgUrl: SimgUrl, // 分享图标
              success() {
                // alert('updateTimelineShareData')
              }
            });
            */


          })

        }).catch((error) => {
          console.warn(error)
        })
      },
      // 全局引导模块
      isPilotRecom(){
        // return
        var $this=this
        // console.log('引导')
        // console.log(localStorage.getItem('fl_pilotRecommend'))
        if(localStorage.getItem('openid')){
          if(!localStorage.getItem('fl_pilotRecommend')){
            setTimeout(function(){
              localStorage.setItem('fl_pilotRecommend','yes')
              $this.fl_pilotRecomPopupShow=true
            },500)
          }else{
            this.FLFirstActivity()
          }
        }

      },
      // 跳过引导
      closePilotRecommend(){
        this.fl_pilotRecomPopupShow=false
        localStorage.setItem('fl_pilotRecommend','yes')
        this.FLFirstActivity()
      },
      // 引导模块最外层 swiper 索引
      flPilotReOutChange(index){
        console.log(index)
        this.fl_psi0_current = index
        // if(index==2){
        //   this.$refs.flPsi3Swiper.swipeTo(0);
        // }
      },
      // 引导模块第二屏 swiper 索引
      flPilotReChange(index){
        this.fl_psi2_current = index;
      },
      // 引导模块第三屏 swiper 索引
      flPilotRe3Change(index){
        this.fl_psi3_current = index
      },
      // 引导模块第三屏 swiper 索引 按钮切换
      flPsi3SwiperTo(item){
        this.$refs.flPsi3Swiper.swipeTo(item);
      },
      // 最外层 swiper next 切换
      flPilotReOutNext(){
        this.$refs.fl_pilotRecom_item.swipeTo(this.fl_psi0_current+1);
      },
      showGuidAg(){
        // console.log('再次显示引导')
        // this.isPilotRecom()
        this.fl_pilotRecomPopupShow=true
      },
      swiperup(){
        // console.log('上划')
        this.closePilotRecommend()
      },


      /**
       * 2021第一次活动
       *  新用户可以看到弹框
       *  无卡用户可以看到弹框
       */
      // 判断是否显示
      FLFirstActivity(){
        // localStorage.setItem('ac_202104011','yes')
        console.log('ac_20210401fouragain')
        if(localStorage.getItem('ac_202104011')=='yes'){
          console.log('已经领券')
          return
        }
        if (this.$cookies.get('ac_20210401fouragain') == 'yes') {
          console.log('break')
          return
        } else {
          var expires = new Date(new Date(new Date().getTime() + 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0));
          this.$cookies.set('ac_20210401fouragain', 'yes', expires)
        }
        console.log('ac_20210401fouragain')
        // return
        var $this=this

        console.log(new Date().getFullYear())
        var sbxqy=new Date().getFullYear()
        console.log(new Date().getMonth()+2)
        var sbxqym=new Date().getMonth()+2
        console.log(new Date().getDate()-1)
        var sbxqyd=new Date().getDate()-1
        this.sbxq=sbxqy+'年'+sbxqym+'月'+sbxqyd+'日'
        // this.flv_activity_first=true
        // 第三次活动
        if(this.$route.name=='index'){
          if(new Date().getTime() >= new Date('2021/04/19').getTime()){
            console.log('活动已结束')
            return
          }else if(localStorage.getItem('ac_20210401fouragain')=='yes'){
            console.log('活动已参与')
            return
          }else{
            this.flv_activity_first=true
          }
        }


        return
        if (localStorage.getItem('ac_20210308') == 'yes') {

        } else {
          if(localStorage.getItem('token')){

            let param = {
              token: localStorage.getItem("token")
            }
            var qs = require('qs');
            let url = this.api.userApi.getInfo
            this.axios.post(url, qs.stringify(param), )
            .then((result) => {
              console.log(result)
              if (result.data) {

                console.log(result.data.user.sex)
                if(result.data.user.sex==2||result.data.user.sex=='2'){
                  localStorage.setItem('ac_20210308','yes')
                  $this.flv_activity_first=true
                  $this.FLVGetCoupon()
                }
              } else {
                // $this.$toast(result.msg)
              }
            }).catch((error) => {
              console.warn(error)
            })



          }
        }
        return
        // 第二次活动
        if(new Date().getTime() >= new Date('2021/02/18').getTime() || new Date().getTime() < new Date('2021/02/11').getTime()){
          console.log('活动已结束')
          return
        }
        console.log(this.$cookies.get('ac_20210205'))
        if (this.$cookies.get('ac_20210205') == 'yes') {
        } else {
          var expires = new Date(new Date(new Date().getTime() + 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0));
          if(localStorage.getItem('token')){
            this.$cookies.set('ac_20210205', 'yes', expires)
            this.flv_activity_first=true
            this.FLVGetCoupon()
          }
        }
        return
        // 第一次活动
        if(localStorage.getItem('ac_20210113')){
          this.flv_activity_first=false
          return
        }
        if(localStorage.getItem('token')){
          var $this = this
          let param = {
            token: localStorage.getItem("token")
          }
          var qs = require('qs');
          let url = this.api.userApi.flUserCardsList
          this.axios.post(url, qs.stringify(param), )
          .then((result) => {
            if (result.code==0) {
              // console.log(result)
              // result.data=[]
              if(result.data&&result.data.length>0){
                // console.log('有会员卡')
                var isOld=0
                for (var i = 0; i < result.data.length; i++) {
                  if(result.data[i].vip_tag=='A1'||result.data[i].vip_tag=='A2'||result.data[i].vip_tag=='B1'||result.data[i].vip_tag=='B2'||result.data[i].vip_tag=='C1'||result.data[i].vip_tag=='C2'){
                    isOld=1
                    break
                  }
                }
                if(isOld==0){
                  if(!localStorage.getItem('ac_20210113')){
                    $this.flv_activity_first=true
                    localStorage.setItem('ac_20210113','yes')
                    $this.FLVGetCoupon()
                  }
                }
              }else{
                // console.log('无会员卡')
                if(!localStorage.getItem('ac_20210113')){
                  $this.flv_activity_first=true
                  localStorage.setItem('ac_20210113','yes')
                  this.FLVGetCoupon()
                }
              }
              // console.log($this.flswiper)
            } else {
              // $this.$toast(result.msg)
            }
          }).catch((error) => {
            // console.warn(error)
          })
        }else{
          // console.warn('no token')
          if(!localStorage.getItem('ac_20210113')){
            this.flv_activity_first=true
          }
        }
      },
      // 触发领卡操作
      FLVGetCoupon(){
        console.log('触发领卡操作')
        var $this = this
        let param = {
          token: localStorage.getItem("token")
        }
        var qs = require('qs');
        let url = this.api.userApi.flUserInAction
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          if (result.code==0) {
            // console.log(result)
            // $this.$toast('优惠券领取成功')
            $this.fl_getcouponSuccess=1
          } else {
            // $this.$toast(result.msg)
          }
        }).catch((error) => {
          // console.warn(error)
        })
      },
      // 开红包
      FLVOpenEnvelope(){
        var $this=this
        if(localStorage.getItem('token')){
          if(this.fl_getcouponSuccess==1){
            setTimeout(function(){
              $this.$toast('优惠券领取成功')
            },1000)
          }

          this.flv_activity_first_isOpen_btn=1
          setTimeout(function(){
            $this.flv_activity_first_isOpen=1
          },500)
          setTimeout(function(){
            $this.flv_activity_first_isOpen_over=1
          },1000)
        }else{
          this.flv_activity_first=false
          setTimeout(function(){
            $this.$router.push({
              name:'login'
            })
          },300)

        }
      },
      // 关闭弹框
      FLVCloseEnvelope(){
        console.log('close')
        if(this.flv_activity_first_isOpen_over==1){
          this.flv_activity_first=false
        }
      },
      // 前往 vip
      FLToVip(){
        var $this=this
        this.flv_activity_first=false
        // console.log(this.flv_activity_first)
        setTimeout(function(){
          $this.$router.push({
            name:'mycoupon'
          })
        },300)
      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  *{
    padding: 0;
    margin: 0;
    font-family:PingFangSC-Medium,PingFang SC,sans-serif;
    box-sizing:border-box;
  }
  div{
    box-sizing:border-box;
  }
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    box-sizing:border-box;
  }
  // 产品引导模块
  .fl_pilotRecom{
    width: 100vw;
    height: 100vh;
    background: #201E1C;
    color: #FFFFFF;
    position: relative;
    // 跳过引导
    .fl_pilotRecom_close{
      display: inline-block;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 9;
      background: rgba(0, 0, 0, 0.5);
      font-size: 24*@vm_base;
      font-weight: 400;
      color: #D5BC7D;
      // line-height: 1;
      letter-spacing: 1px;
      padding: 12*@vm_base 30*@vm_base;
      margin-top: 60*@vm_base;
      margin-right: 40*@vm_base;
    }
    // 最外层 swiper 下一页按钮
    .fl_pilotRecom_next{
      position: absolute;
      bottom: 0;
      left: 0;
      margin-left: calc(50% - 20*@vm_base);
      margin-bottom: 30*@vm_base;
      z-index: 9;
      width: 40*@vm_base;
    }
    .fl_pilotRecom_next0{
      margin-bottom: 30*@vm_base;
    }
    .fl_pilotRecom_next1{
      margin-bottom: 83*@vm_base;
    }
    .fl_pilotRecom_next2{
      margin-bottom: 30*@vm_base;
    }

    // 最外层 swiper 背景图
    .fl_pilotRecom_item{
      background-image: url(./assets/images/guid/bg_principleflatten.png);
      background-position: center top;
      background-repeat: no-repeat;
      background-size: 100% auto;
    }
    // 最外层 swiper 每个 item 尺寸
    .fl_pilotRecom_swipeitem{
      width: 100%;
      height: 100vh;
      // swiper 1
      .fl_psi1{
        width: 100%;
        padding-top: 60*@vm_base;
        padding-left: 80*@vm_base;
        .fl_psi1_logo{
          width: 141*@vm_base;
        }
        .fl_psi1_title{
          width: 100%;
          font-size: 40*@vm_base;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 1;
          letter-spacing: 1px;
          margin-top: 60*@vm_base;
          margin-bottom: 24*@vm_base;
        }
        .fl_psi1_stitle{
          width: 100%;
          font-size: 28*@vm_base;
          font-weight: 400;
          color: #FCF9F4;
          line-height: 1.143;
          margin-bottom: 46*@vm_base;
        }
        .fl_psi1_stitleH{
          margin-bottom: 76*@vm_base;
        }
      }
      .fl_psi1H{
        padding-top: 110*@vm_base;
      }
      .fl_psi1_img{
        width: calc(100% - 80*@vm_base);
      }
      // swiper 2
      .fl_psi2_title{
        width: 100%;
        padding: 100*@vm_base 80*@vm_base 0 80*@vm_base;
        .fl_psi2_title1{
          width: 100%;
          font-size: 40*@vm_base;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 1;
          letter-spacing: 1px;
          margin-bottom: 20*@vm_base;
        }
        .fl_psi2_title2{
          width: 1100%;
          font-size: 20*@vm_base;
          font-weight: 400;
          color: #A4A4A3;
          line-height: 1;
          margin-bottom: 60*@vm_base;
        }
        .fl_psi2_title2H{
          margin-bottom: 90*@vm_base;
        }
      }
      .fl_psi2_titleH{
        padding: 130*@vm_base 80*@vm_base 0 80*@vm_base;
      }
      .fl_psi2_cont{
        width: 100%;
        padding: 210*@vm_base 0 0 40*@vm_base;
        position: relative;
        .fl_psi2_cont_bg{
          width: calc(100% - 40*@vm_base);
          margin-left: 40*@vm_base;
          height: 640*@vm_base;
          background: linear-gradient(143deg, #E3D8C5 0%, #AE916D 100%);
          position: relative;
          padding: 15*@vm_base;
          .fl_psi2_cont_bg_line{
            width: 100%;
            height: 100%;
            border: 2*@vm_base solid;
            border-image: linear-gradient(143deg, rgba(213, 197, 152, 1), rgba(196, 173, 127, 1)) 2 2;
          }
          .fl_psi2_cont_bg_txt{
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            padding: 0 0 54*@vm_base 120*@vm_base;
            color: #5B412B;
            .fl_psi2_cont_bg_txt1{
              width: 100%;
              font-size: 36*@vm_base;
              font-weight: bold;
              color: #5B412B;
              line-height: 1;
            }
            .fl_psi2_cont_bg_txt2{
              margin-top: 40*@vm_base;
              width: 100%;
              font-size: 28*@vm_base;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #5B412B;
              line-height: 1.43;
            }
          }
        }
        .fl_psi2_cont_swiper{
          position: absolute;
          width: calc(100% - 80*@vm_base);
          top: 0;
          left: 0;
          margin-left: 40*@vm_base;
          .fl_psi2_cont_swiper_swipe{
            width: 100%;
          }
        }
        .fl_psi2_cont_custom_indicator{
          position: absolute;
          top: 0;
          right: 0;
          margin-top: 20*@vm_base;
          margin-right: 20*@vm_base;
          background: rgba(0, 0, 0, 0.25);
          font-size: 20*@vm_base;
          font-weight: 400;
          color: #FFFFFF;
          padding: 5*@vm_base 17*@vm_base;
          label{
            display: inline-block;
            font-size: 28*@vm_base;
          }
        }
      }
      // swiper 3
      .fl_psi3_title{
        padding: 100*@vm_base 80*@vm_base 50*@vm_base 80*@vm_base;
        .fl_psi3_title1{
          width: 100%;
          font-size: 40*@vm_base;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 1;
          letter-spacing: 1px;
        }
        .fl_psi3_title2{
          width: 100%;
          margin-top: 20*@vm_base;
          font-size: 20*@vm_base;
          font-weight: 400;
          color: #A4A4A3;
          line-height: 1;
          text-transform : uppercase
        }
      }
      .fl_psi3_titleH{
        padding: 130*@vm_base 80*@vm_base 80*@vm_base 80*@vm_base;
      }
      .fl_psi3_swiper{
        width: calc(100% - 70*@vm_base);
        background: linear-gradient(143deg, #E3D8C5 0%, #AE916D 100%);
        padding: 15*@vm_base;
        .fl_psi3_swiper_item{
          width: 100%;
          border: 2*@vm_base solid;
          border-image: linear-gradient(143deg, rgba(213, 197, 152, 1), rgba(196, 173, 127, 1)) 2 2;
          padding: 45*@vm_base 0 24*@vm_base 45*@vm_base;
          .fl_psi3_swiper_item_title{
            width: 100%;
            font-size: 27*@vm_base;
            font-weight: 500;
            color: #5B412B;
            white-space: nowrap;
            .fl_psi3_swiper_item_title_border{
              border: 2*@vm_base solid #5B412B;
            }
            span{
              display: inline-block;
              padding: 9*@vm_base 24*@vm_base;
              position: relative;
              img{
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 68*@vm_base;
              }
            }
          }
          .fl_psi3_swiper_item_sw{
            width: calc(100% + 50*@vm_base);
            padding: 40*@vm_base 0 36*@vm_base 0;
          }
          .fl_psi3_swiper_item_tip{
            width: 100%;
            // height: 24px;
            font-size: 24*@vm_base;
            // font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #5B412B;
            // line-height: 24px;

          }
        }
      }
      // swiper 4
      .fl_psi4_title{
        padding: 100*@vm_base 80*@vm_base 50*@vm_base 80*@vm_base;
        .fl_psi4_title1{
          width: 100%;
          font-size: 40*@vm_base;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 1;
          letter-spacing: 1px;
        }
        .fl_psi4_title2{
          width: 100%;
          margin-top: 20*@vm_base;
          font-size: 20*@vm_base;
          font-weight: 400;
          color: #A4A4A3;
          line-height: 1;
          text-transform : uppercase
        }
      }
      .fl_psi4_titleH{
        padding: 130*@vm_base 80*@vm_base 80*@vm_base 80*@vm_base;
      }
      .fl_psi4_cont{
        width: 100%;
        padding: 60*@vm_base 50*@vm_base 0 40*@vm_base;
        // border: 1px solid red;
        position: relative;
        .fl_psi4_cont_block{
          width: calc(100% - 30*@vm_base);
          margin-left: 30*@vm_base;
          // margin-top: 60*@vm_base;
          height: 58vh;
          background: linear-gradient(143deg, #E3D8C5 0%, #AE916D 100%);
          padding: 15*@vm_base;
          .fl_psi4_cont_block_item{
            display: flex;
            width: 100%;
            height: 100%;
            border: 2*@vm_base solid;
            border-image: linear-gradient(143deg, rgba(213, 197, 152, 1), rgba(196, 173, 127, 1)) 2 2;

          }
        }
        .fl_psi4_cont_blockH{
          height: 48vh;
        }
        .fl_psi4_cont_pos{
          position: absolute;
          top: 0;
          left: 0;
          width: calc(100% - 130*@vm_base);
          margin-left: 40*@vm_base;
          // border: 1px solid red;
          .fl_psi4_cont_pos_img1{
            width: 100%;
          }
          .fl_psi4_cont_pos_img2{
            width: 47.6%;
            margin-top: -29%;
          }
          .fl_psi4_cont_pos_img3{
            width: 47.6%;
            margin-top: 10*@vm_base;
          }
          .fl_psi4_cont_pos_img4{
            width:calc(52.4% - 10*@vm_base);
            margin-top: -62%;
            float: right;
          }
        }
      }
      // swiper 5
      .fl_psi5_cont{
        width: 100%;
        padding: 160*@vm_base 60*@vm_base 0 0;
        position: relative;
        .fl_psi5_cont_block{
          width: calc(100% - 60*@vm_base);
          height: 58vh;
          background: linear-gradient(143deg, #E3D8C5 0%, #AE916D 100%);
          padding: 15*@vm_base;
          .fl_psi5_cont_block_item{
            display: flex;
            width: 100%;
            height: 100%;
            border: 2*@vm_base solid;
            border-image: linear-gradient(143deg, rgba(213, 197, 152, 1), rgba(196, 173, 127, 1)) 2 2;
          }
        }
        .fl_psi5_cont_blockH{
          height: 48vh;
        }
        .fl_psi5_cont_pos{
          position: absolute;
          top: 0;
          left: 0;
          width: calc(100% - 150*@vm_base);
          margin-left: 90*@vm_base;
          .fl_psi5_cont_pos_img1{
            width: 50%;
            float: left;
          }
          .fl_psi5_cont_pos_img2{
            width: 50%;
            float: left;
          }
          .fl_psi5_cont_pos_img3{
            width: calc(100% + 50*@vm_base);
            margin-left: -50*@vm_base;
          }
          .fl_psi5_cont_pos_img4{
            width: 100%;
          }
        }
      }
      // swiper 6
      .fl_psi6_cont{
        width: 100%;
        padding: 160*@vm_base 0 0 70*@vm_base;
        position: relative;
        .fl_psi6_cont_block{
          width: calc(100% - 110*@vm_base);
          height: 58vh;
          margin-left: 110*@vm_base;
          background: linear-gradient(143deg, #E3D8C5 0%, #AE916D 100%);
          padding: 15*@vm_base;
          .fl_psi6_cont_block_item{
            display: flex;
            width: 100%;
            height: 100%;
            border: 2*@vm_base solid;
            border-image: linear-gradient(143deg, rgba(213, 197, 152, 1), rgba(196, 173, 127, 1)) 2 2;
          }
        }
        .fl_psi6_cont_blockH{
          height: 48vh;
        }
        .fl_psi6_cont_pos{
          position: absolute;
          top: 0;
          left: 0;
          width: calc(100% - 70*@vm_base);
          margin-left: 70*@vm_base;
          .fl_psi6_cont_pos_img1{
            width: calc(100% - 80*@vm_base);
          }
          .fl_psi6_cont_pos_img2{
            width: 49%;
            margin-top: 10*@vm_base;
            float: left;
          }
          .fl_psi6_cont_pos_img3{
            width: 51%;
            margin-top: -6%;
          }
        }
      }
      // swiper 7
      .fl_psi7_cont{
        width: 100%;
        padding: 120*@vm_base 40*@vm_base 0 80*@vm_base;
        position: relative;
        .fl_psi7_cont_block{
          width: 100%;
          height: 58vh;
          background: linear-gradient(143deg, #E3D8C5 0%, #AE916D 100%);
          padding: 15*@vm_base;
          position: relative;
          .fl_psi7_cont_block_item{
            display: flex;
            width: 100%;
            height: 100%;
            border: 2*@vm_base solid;
            border-image: linear-gradient(143deg, rgba(213, 197, 152, 1), rgba(196, 173, 127, 1)) 2 2;
          }
          .fl_psi7_cont_block_btn{
            width: 300*@vm_base;
            // background: linear-gradient(135deg, #0A0A0A 0%, #4B3D31 100%);
            // box-shadow: 0px 0px 70*@vm_base 0px rgba(242, 206, 136, 0.2);
            // font-size: 28*@vm_base;
            font-weight: 500;
            color: #F2CE88;
            text-align: center;
            padding: 20*@vm_base;
            position: absolute;
            left: 0;
            bottom: 0;
            margin-left: calc(50% - 150*@vm_base);
            margin-bottom: -50*@vm_base;
          }
          .fl_psi7_cont_block_silder{
             width: 200vw;
             height: 100vh;
             margin-left: -100vw;
          }
        }
        .fl_psi7_cont_blockH{
          height: 48vh;
        }
        .fl_psi7_cont_pos{
          position: absolute;
          top: 0;
          left: 0;
          width: calc(100% - 80*@vm_base);
          img{
            width: 100%;
          }
          div{
            width: 100%;
            padding: 60*@vm_base 0 0 180*@vm_base;
            font-size: 28*@vm_base;
            font-weight: 500;
            color: #69513D;
            letter-spacing: 1px;
          }
        }
      }
    }
  }

  // 2021-第一个活动
  .flvf_popup{
    width: 100%;
    position: relative;
    .flvf_popup_img1{
      width: 80%;
      margin-left: 10%;
    }
    .flvf_popup_img2{
      width: 66.15%;
      margin-left:15.27%;
      margin-top: -60*@vm_base;
    }
    .flvf_popup_img3{
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
      width: 150*@vm_base;
      height: 150*@vm_base;
      margin-left: calc(50% - 75*@vm_base);
      margin-top: 320*@vm_base;
    }
    .flvf_popup_img4{
      width: 78.6%;
      margin-left: 10.7%;
      position: relative;
      img{
        width: 100%;
        margin-top: -20*@vm_base;
      }
      .flvf_popup_img4_txt{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        padding: 285*@vm_base 0 0 250*@vm_base;
        .flvf_popup_img4_txt_title{
          width: 100%;
          font-size: 28*@vm_base;
          font-weight: 500;
          color: #333333;
          line-height: 1;
          white-space: nowrap;
          font-weight: bold;
        }
        .flvf_popup_img4_txt_stitle{
          width: 100%;
          font-size: 22*@vm_base;
          font-weight: 400;
          color: #666666;
          line-height: 1;
          margin-top: 16*@vm_base;
          margin-bottom: 10*@vm_base;
          white-space: nowrap;
        }
        .flvf_popup_img4_txt_date{
          width: 100%;
          font-size: 22*@vm_base;
          font-weight: 400;
          color: #666666;
          line-height: 1;
          white-space: nowrap;
        }
      }
      // img{
      //   width: 100%;
      // }
      // .flvf_popup_img4_btn{
      //   position: absolute;
      //   bottom: 0;
      //   left: 0;
      //   width: 526*@vm_base;
      //   height: 80*@vm_base;
      //   background: linear-gradient(136deg, #FBF0CC 0%, #DC8659 100%);
      //   border-radius: 12*@vm_base;
      //   font-size: 32*@vm_base;
      //   font-weight: 500;
      //   color: #C93A1F;
      //   margin-left: calc(50% - 263*@vm_base);
      //   margin-bottom: 44*@vm_base;
      // }
      // button:before {
      //     display: block;
      //     background: rgba(255, 255, 255, 0.5);
      //     width: 0px;
      //     height: 100%;
      //     position: absolute;
      //     content: '';
      //     left: 0*@vm_base;
      //     top: 0;
      //     -webkit-animation: glint 1.6s;
      //     animation: glint 4.6s;
      //     opacity: 0;
      //     -webkit-filter: blur(30px);
      //     filter: blur(30px);
      //     -webkit-transform: translateX(-0px) skewX(-15deg);
      //     -ms-transform: translateX(-0px) skewX(-15deg);
      //     transform: translateX(-0px) skewX(-15deg);
      //     opacity: 0;
      //     border: 1px solid red;
      // }
      // button:after {
      //     display: block;
      //     background: rgba(255, 255, 255, 0.2);
      //     width: 30px;
      //     height: 100%;
      //     position: absolute;
      //     content: '';
      //     left: -90*@vm_base;
      //     top: 0;
      //     -webkit-animation: glintier 1s;
      //     animation: glintier 4.6s infinite;
      //     opacity: 0.6;
      //     -webkit-filter: blur(5px);
      //     filter: blur(5px);
      //     -webkit-transform: translateX(526*@vm_base) skewX(-15deg);
      //     -ms-transform: translateX(526*@vm_base) skewX(-15deg);
      //     transform: translateX(526*@vm_base) skewX(-15deg);
      //     opacity: 0.6;
      // }
      // @-webkit-keyframes glint {
      //     0% {
      //         -webkit-transform: translateX(-50px) skewX(-15deg);
      //         transform: translateX(-50px) skewX(-15deg);
      //         opacity: 0;
      //     }
      //     100% {
      //         -webkit-transform: translateX(526*@vm_base) skewX(-15deg);
      //         transform: translateX(526*@vm_base) skewX(-15deg);
      //         opacity: 0.6;
      //     }
      // }
      // @keyframes glint {
      //     0% {
      //         -webkit-transform: translateX(-50px) skewX(-15deg);
      //         transform: translateX(-50px) skewX(-15deg);
      //         opacity: 0;
      //     }
      //     100% {
      //         -webkit-transform: translateX(526*@vm_base) skewX(-15deg);
      //         transform: translateX(526*@vm_base) skewX(-15deg);
      //         opacity: 0.6;
      //     }
      // }
      // @-webkit-keyframes glintier {
      //     0% {
      //         -webkit-transform: translateX(-526*@vm_base) skewX(-15deg);
      //         transform: translateX(-526*@vm_base) skewX(-15deg);
      //         opacity: 0;
      //     }
      //     100% {
      //         -webkit-transform: translateX(526*@vm_base) skewX(-15deg);
      //         transform: translateX(526*@vm_base) skewX(-15deg);
      //         opacity: 0.6;
      //     }
      // }
      // @keyframes glintier {
      //     0% {
      //         -webkit-transform: translateX(-526*@vm_base) skewX(-15deg);
      //         transform: translateX(-526*@vm_base) skewX(-15deg);
      //         opacity: 0;
      //     }
      //     100% {
      //         -webkit-transform: translateX(526*@vm_base) skewX(-15deg);
      //         transform: translateX(526*@vm_base) skewX(-15deg);
      //         opacity: 0.6;
      //     }
      // }
    }
    .flvf_popup_clos{
      width: 48*@vm_base;
      margin: 40*@vm_base auto 0 auto;
    }
  }

  //
  .flvf_popup_minprogress{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 3000;
    background: #FFFFFF;
    width: 100%;
    height: 100vh;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    .flvf_popup_minprogress_img{
      width: 100%;
      padding: 20vh 20% 0 20%;
      .flvf_popup_minprogress_imgi{
        width: 100%;
      }
    }
    .flvf_popup_minprogress_txt{
      width: 100%;
      text-align: center;
      padding: 120*@vm_base 0 60*@vm_base 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue